import Reqwest from 'reqwest';

const BaseRequest = (url, method, headers, data) =>
  Reqwest({ url, method, headers, data, type: 'json', contentType: 'application/json' });

module.exports = {
  get: (url, headers, params) => BaseRequest(url, 'get', headers, params),
  post: (url, headers, data) => BaseRequest(url, 'post', headers, data),
};



// WEBPACK FOOTER //
// ./utils/ajax.js